export default __webpack_public_path__ + "static/media/Expert.d4d562f8.png";